import { DatePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { EmptyStateComponent } from '../../../../ui/empty-state/empty-state.component';
import { ErrorStateComponent } from '../../../../ui/error-state/error-state.component';
import { QuestionReview } from '../../../../../core/interfaces/question-review';

/**
 * Historique des décisions de relecture d'une question.
 *
 * Composant **présentationnel** : il reçoit la liste déjà chargée, l'état de
 * chargement et l'état d'erreur. Un échec réseau affiche `app-error-state` et
 * réémet la demande de rechargement — jamais de données de substitution.
 */
@Component({
  selector: 'app-review-history',
  standalone: true,
  imports: [DatePipe, TranslateModule, EmptyStateComponent, ErrorStateComponent],
  templateUrl: './review-history.component.html',
  styleUrl: './review-history.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReviewHistoryComponent {
  /** Décisions passées, de la plus récente à la plus ancienne côté back. */
  @Input() reviews: QuestionReview[] = [];

  @Input() loading = false;

  /** Vrai quand l'appel `history(id)` a échoué. */
  @Input() errored = false;

  @Output() retry = new EventEmitter<void>();
}
